//Returns an object with same keys as object but with true as value
export function copyObjectWithNewValues(object, value = true) {
    const tempArray = Object.keys(object);
    return tempArray.reduce((acc, curr) => {
        return { ...acc, [curr]: value };
    }, {});
}
